export enum PaymentMethodType {
  PAYMENT = 'payment',
  WITHDRAWAL = 'withdrawal',
  REFERRALS = 'referrals',
}
